import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.countdownDate = 0;
        this.$dom = {};
        this.setinterval = undefined;

        this.init();
    }

    /**
     * Initialisation.
     *
     */
    init() {
        // dom elements
        this.countdownDate = this.$el.data('countdown');
        this.$dom.days = this.$el.find('.js-countdown-days');
        this.$dom.hours = this.$el.find('.js-countdown-hours');
        this.$dom.minutes = this.$el.find('.js-countdown-minutes');
        this.$dom.seconds = this.$el.find('.js-countdown-seconds');

        // on execute le script toute les secondes
        // pour mettre à jour le compteur
        this.setinterval = setInterval(() => {
            const date = this.getTimeRemaining(this.countdownDate);

            // mise à jour du compteur
            this.updateDays(date.days);
            this.updateHours(date.hours);
            this.updateMinutes(date.minutes);
            this.updateSeconds(date.seconds);

            // si le compteur est terminé
            if (date.total <= 0) {
                clearInterval(this.setinterval);
            }
        }, 1000);
    }

    /**
     * Permet un formatage correct des chiffres.
     * Ex: leftPad(7, 2) --> 07
     *
     * @param {string} number        nombre à formater
     * @param {string} targetLength  nombre de chiffres attendu en sortie
     */
    leftPad(number, targetLength) {
        let output = number + '';
        while (output.length < targetLength) {
            output = '0' + output;
        }
        return output;
    }

    /**
     * Obtenir le temps restant en fonction d'une date.
     * Pour gérer correctement le décalage horaire,
     * on se base sur le fornat GMT.
     *
     * @param {string} countdown  date de fin
     */
    getTimeRemaining(countdown) {
        const current = new Date().getTime();
        let total = Date.parse(countdown) - current;
        if (total <= 0) total = 0;

        return {
            'total': total,
            'days': Math.floor(total / (1000 * 60 * 60 * 24)),
            'hours': Math.floor((total / (1000 * 60 * 60)) % 24),
            'minutes': Math.floor((total / 1000 / 60) % 60),
            'seconds': Math.floor((total / 1000) % 60),
        };
    }

    /**
     * Mettre à jour l'affichage des jours.
     *
     * @param {string} days  nombre de jours à afficher
     */
    updateDays(days) {
        days = this.leftPad(days, 2);
        this.animateDigit(this.$dom.days, days[0], 9, 'right');
        this.animateDigit(this.$dom.days, days[1], 9, 'left');
        if (days > 99) {
            this.animateDigit(this.$dom.days, days[2], 9, 'big');
            this.$dom.days.addClass('is-big');
        } else {
            this.$dom.days.removeClass('is-big');
        }
    }

    /**
     * Mettre à jour l'affichage des heures.
     *
     * @param {string} days  nombre de heures à afficher
     */
    updateHours(hours) {
        hours = this.leftPad(hours, 2);
        this.animateDigit(this.$dom.hours, hours[0], 2, 'right');
        if (hours === '00') {
            this.animateDigit(this.$dom.hours, hours[1], 3, 'left');
        } else {
            this.animateDigit(this.$dom.hours, hours[1], 9, 'left');
        }
    }

    /**
     * Mettre à jour l'affichage des minutes.
     *
     * @param {string} days  nombre de minutes à afficher
     */
    updateMinutes(minutes) {
        minutes = this.leftPad(minutes, 2);
        this.animateDigit(this.$dom.minutes, minutes[0], 5, 'right');
        this.animateDigit(this.$dom.minutes, minutes[1], 9, 'left');
    }

    /**
     * Mettre à jour l'affichage des secondes.
     *
     * @param {string} days  nombre de secondes à afficher
     */
    updateSeconds(seconds) {
        seconds = this.leftPad(seconds, 2);
        this.animateDigit(this.$dom.seconds, seconds[0], 5, 'right');
        this.animateDigit(this.$dom.seconds, seconds[1], 9, 'left');
    }

    /**
     * Animation du digit dans le DOM.
     *
     * @param {string} el      élément à modifier
     * @param {string} number  nombre à afficher
     * @param {string} max     nombre maximum que peut afficher le compteur
     * @param {string} name    chiffre `left`, `right`, `big`
     */
    animateDigit(el, number, max, name) {
        const digits = el.find(`.js-countdown-${name}`);
        const old = (number === '0') ? max : number - 1;

        digits.find('.js-digit').removeClass('is-old is-show');
        digits.find(`[data-number="${old}"]`).addClass('is-old');
        digits.find(`[data-number="${number}"]`).addClass('is-show');
    }

    destroy() {
        clearInterval(this.setinterval);
        this.$el.off('.Countdown');

        delete(this.setinterval);
        delete(this.countdownDate);
        delete(this.$dom);
    }
}
